module.exports = __webpack_public_path__ + "static/img/netiquette.f1a71c61.jpg";